import ScrollReveal from '@/components/base/ScrollReveal';

export default function PackagingTeaser() {
  return (
    <section className="bg-secondary-100 py-14 md:py-20">
      <div className="max-w-none mx-auto px-4 md:px-6">
        <ScrollReveal>
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-2">
              Gift-Grade Packaging, Every Time
            </h2>
            <p className="text-sm md:text-base text-foreground-500 font-label max-w-lg mx-auto">
              Every Joviaa piece arrives in a magnetic gift box with a thank-you
              card and anti-tarnish pouch — because your jewellery deserves a
              first impression as beautiful as the piece itself.
            </p>
          </div>
        </ScrollReveal>
        <div className="grid grid-cols-3 gap-3 md:gap-4 max-w-3xl mx-auto">
          <ScrollReveal delay={0}>
            <div className="aspect-[3/4] rounded-2xl overflow-hidden bg-background-50">
              <img
                src="https://readdy.ai/api/search-image?query=Premium%20magnetic%20gift%20box%20in%20blush%20pink%20with%20gold%20foil%20logo%20open%20on%20warm%20cream%20surface%2C%20luxe%20unboxing%20experience%2C%20soft%20lighting%2C%20editorial%20product%20photography&width=600&height=800&seq=pkg-box&orientation=portrait"
                alt="Joviaa magnetic gift box"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </ScrollReveal>
          <ScrollReveal delay={120}>
            <div className="aspect-[3/4] rounded-2xl overflow-hidden bg-background-50">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20gold%20foil%20thank%20you%20card%20on%20blush%20tissue%20paper%20with%20soft%20warm%20lighting%2C%20premium%20gift%20packaging%20detail%2C%20editorial%20photography%2C%20minimal%20composition&width=600&height=800&seq=pkg-card&orientation=portrait"
                alt="Joviaa thank-you card"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </ScrollReveal>
          <ScrollReveal delay={240}>
            <div className="aspect-[3/4] rounded-2xl overflow-hidden bg-background-50">
              <img
                src="https://readdy.ai/api/search-image?query=Soft%20beige%20anti%20tarnish%20jewellery%20pouch%20with%20gold%20chain%20peeking%20out%20on%20warm%20cream%20background%2C%20premium%20storage%2C%20editorial%20product%20photography%2C%20soft%20lighting&width=600&height=800&seq=pkg-pouch&orientation=portrait"
                alt="Joviaa anti-tarnish pouch"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}